import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import "./text_section_overview_amenities.css";

const context = require.context('./', true, /_controller\.js$/);
application.load(definitionsFromContext(context));